/* eslint-disable no-nested-ternary */
import React from 'react';

import d2d from '@assets/img/icons/d2d-new.svg';
import { Button } from '@components/Button';
import { makeMuiStyles, useCommonStyles } from '@styles';
import { createStrings } from '@utils/local';
import clsx from 'clsx';

const strings = createStrings({
  ja: {
    refresh: '再読込',
  },
});

const useStyles = makeMuiStyles((theme, common) => ({
  errors: {
    ...common.flexColumnCenter,
    ...common.normalText,
    ...common.fontWeight500,
    ...common.textGray800,
    flex: 1,
    '& a': {
      ...common.textPrimary,
      textDecoration: 'underline',
    },
  },
  errorTextContainer: {
    textAlign: 'center',
  },
  errorLogo: {
    height: 52 * 0.9,
    width: 182 * 0.9,
    marginBottom: '2rem',
  },
}));

export interface LoadingErrorsFallbackProps {
  prompt: React.ReactNode;
  errors?: unknown[];
  children: () => React.ReactNode;
}

export const LoadingErrorsFallback: React.FC<LoadingErrorsFallbackProps> = (props) => {
  const { prompt, errors = [], children } = props;

  const cleanedErrors = errors.filter((e) => Boolean(e));
  const hasErrors = cleanedErrors.length > 0;

  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  if (!hasErrors) {
    return <>{children()}</>;
  }

  return (
    <div className={classes.errors}>
      <a href="/">
        <img className={clsx(classes.errorLogo, classes.baseButton)} src={d2d} alt="D2D Logo" />
      </a>

      <div className={classes.errorTextContainer}>{prompt}</div>

      <div style={{ height: 30 }} />

      <Button
        text={strings.refresh}
        color="primary"
        onClick={() => {
          window.location.href = '';
        }}
        style={{ width: 120 }}
        shape="round"
      />
    </div>
  );
};
